export default {
  namespaced: true,
  state: {
    cart: [],
  },

  mutations: {
    setCart(state, cart) {
      console.log('status', cart);
      state.cart = cart;
    },

    removeProduct(state, { userId, productId, size }) {
      let updatedCart;
      console.log(size)
      if (userId === 'guest') {
        // Получаем корзину гостя из localStorage, если она существует, или создаем пустой массив
        const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
        
        // Если guestCart существует и является массивом, выполняем filter
        updatedCart = guestCart.filter(product => {
          return !(product.productId._id === productId && product.size === size);
        });
    
        // Сохраняем обновленную корзину в localStorage
        localStorage.setItem('guestCart', JSON.stringify(updatedCart));
    
      } else {
        updatedCart = {
          ...state.cart,
          products: state.cart.products.filter(product => {
            return !(product.productId._id === productId && product.size === size);
          })
        };
      }

      // вызываем setCart с новым значением
      this.commit('cart/setCart', updatedCart);
    }
  },

  actions: {
    async addToCart(context, { userId, productId, size }) {
      console.log('Отправляемые данные в запросе:', { userId, productId, size });

      if (userId === 'guest') {
        // Получаем текущую корзину для гостя из localStorage или создаем новую
        const existingCart = JSON.parse(localStorage.getItem('guestCart')) || [];
        
        // Проверяем, есть ли уже этот товар с таким же размером в корзине
        const existingProductIndex = existingCart.findIndex(
          (item) => item.productId === productId && item.size === size);

        if (existingProductIndex >= 0) {
          // Если товар с таким же размером уже есть в корзине, увеличиваем его количество
          existingCart[existingProductIndex].quantity += 1;
        } else {
          // Если товара нет в корзине, добавляем его с начальным количеством
          existingCart.push({ productId, size, quantity: 1 });
        }

        console.log("cart:", existingCart);

        
        // Обновляем корзину в Vuex
        context.commit('setCart', existingCart);
        
        // Сохраняем обновленную корзину в localStorage
        localStorage.setItem('guestCart', JSON.stringify(existingCart));
        return;
      } else {
        try {
          const response = await fetch(`${process.env.VUE_APP_URL}/cart`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId, productId, size }),
          });

          if (response.ok) {
            const data = await response.json();
            console.log('Товар успешно добавлен в корзину:', data);
          } else {
            const errorData = await response.json();
            console.error('Ошибка при добавлении в корзину:', errorData);
          }
        } catch (error) {
          console.error('Ошибка при выполнении запроса:', error);
        }
      }
    },

    async fetchCart(context, userId) {
      if (userId === 'guest') {
        const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];

        try {
          const res = await fetch(`${process.env.VUE_APP_URL}/products`);
          if (!res.ok) {
            throw new Error(`Ошибка при получении всех товаров: ${res.status}`);
          }

          const allProducts = await res.json();

          const fullProductCart = guestCart.map(item => {
            console.log(item)
            const product = allProducts.find(p => p._id === item.productId);
            if (product) {
              return {
                _id: item._id || item.productId, 
                productId: product,
                size: item.size,
                quantity: item.quantity,
              };
            }
          }).filter(product => product !== undefined);
          
          console.log('full', fullProductCart);

          // Коммитим данные в Vuex
          context.commit('setCart', fullProductCart);

        } catch (error) {
          console.error('Ошибка при загрузке данных корзины:', error);
        }
      } else {
        try {
          const response = await fetch(`${process.env.VUE_APP_URL}/cart/${userId}`);
          if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
          }

          const data = await response.json();
          console.log('дата авторизованого пользователя:', data);

          // Коммит данных в Vuex
          context.commit('setCart', data); // Здесь уже данные корзины от сервера

        } catch (error) {
          console.error('Error fetching cart data:', error);
        }
      }
    },
    async removeFromCart(context, { userId, productId, size }) {
      if (userId === 'guest') {
        const guestCart = JSON.parse(localStorage.getItem('guestCart')) || [];
        const updatedCart = guestCart.filter(item => !(item.productId === productId && item.size === size));
    
        localStorage.setItem('guestCart', JSON.stringify(updatedCart));
        
        //сразу вызвать fetchCart, чтобы productId стал полноценным объектом
        await context.dispatch('fetchCart', userId);
    
      } else {
        try {
          const response = await fetch(`${process.env.VUE_APP_URL}/cart`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userId, productId, size })
          });

          if (response.ok) {
            const data = await response.json();
            context.commit('removeProduct', { userId, productId, size })
            console.log('Товар успешно удален из корзины:', data);
          } else {
            const errorData = await response.json();
            console.error('Ошибка при удалении из корзины:', errorData);
          }

        } catch (error) {
          console.error(error)
        }
      }
    }
  },

  getters: {
    getCart(state) {
      return state.cart || [];
    },
    getAmountOfProducts(state) {
      return state.amountOfProducts;
    }
  }
};
